var React = require('react');

function Window95Inline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"55","height":"16","fill":"white","key":0}),React.createElement("rect",{"x":"5","y":"12","width":"8","height":"1","fill":"#1A8F50","key":1}),React.createElement("rect",{"x":"43","y":"4","width":"11.3137","height":"1.41421","transform":"rotate(45 43 4)","fill":"#1A8F50","key":2}),React.createElement("rect",{"width":"11.3137","height":"1.41421","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 50 4)","fill":"#1A8F50","key":3}),React.createElement("rect",{"x":"23.5","y":"4.5","width":"8","height":"8","stroke":"#1A8F50","key":4})]);
}

Window95Inline.defaultProps = {"width":"55","height":"16","viewBox":"0 0 55 16","fill":"none"};

module.exports = Window95Inline;

Window95Inline.default = Window95Inline;
